export default {
  TableHead: [
    [
      {
        displayName: 'activity.number',
      },
      {
        displayName: 'activity.username',
      },
      {
        displayName: 'IPAddress',
      },
      {
        displayName: 'activity.type',
      },
      {
        displayName: 'activity.datetime',
      },
    ],
  ],
};
